import { categoriaExameInformacao } from "../shared/utils/enum";

const ATUALIZAR_BAIXANDO_PDF = "helpExame/ATUALIZAR_BAIXANDO_PDF";
const ATUALIZAR_CATEGORIA_EXAME_SELECIONADA = "helpExame/ATUALIZAR_CATEGORIA_EXAME";
const ATUALIZAR_LISTA_COMPLETA_EXAMES = "helpExame/ATUALIZAR_LISTA_COMPLETA_EXAMES";
const ATUALIZAR_LISTA_EXAMES_FILTRADOS = "helpExame/ATUALIZAR_LISTA_EXAMES_FILTRADOS";
const ATUALIZAR_LISTA_EXAMES_BUSCA_MULTIPLA = "helpExame/ATUALIZAR_LISTA_EXAMES_BUSCA_MULTIPLA";
const ATUALIZAR_BUSCA_MULTIPLA_HABILITADA = "helpExame/ATUALIZAR_BUSCA_MULTIPLA_HABILITADA";
const ATUALIZAR_TIPO_APOIO = "helpExame/ATUALIZAR_TIPO_APOIO";
const ATUALIZAR_UNIDADE_PRODUTIVA = "helpExame/ATUALIZAR_UNIDADE_PRODUTIVA";
const ATUALIZAR_UNIDADE_DE_NEGOCIO = "helpExame/ATUALIZAR_UNIDADE_DE_NEGOCIO";
const ATUALIZAR_EMPRESA_PSC = "helpExame/ATUALIZAR_EMPRESA_PSC";
const ATUALIZAR_CODIGO_LC = "helpExame/ATUALIZAR_CODIGO_LC";
const LIMPAR_FILTROS_EXAME = "helpExame/LIMPAR_FILTROS_EXAME";
const ATUALIZAR_LOADING_VISUALIZACAO_EXAME = "helpExame/ATUALIZAR_LOADING_VISUALIZACAO_EXAME";
const GERAR_RODAPE_EMPRESA = "helpExame/GERAR_RODAPE_EMPRESA";
const ATUALIZAR_PESQUISA_EXAME = "helpExame/ATUALIZAR_PESQUISA_EXAME";

const dataAtual = new Date();

const rodapeEmpresaInitialState = {
  copyright: `Hermes Pardini Â© 2019 - ${dataAtual.getFullYear()}`,
  nome: "Hermes Pardini",
  urlSite: "https://www.hermespardini.com.br",
  urlPoliticaPrivacidade: "https://www.hermespardini.com.br/politicas-de-privacidade",
  telefone: "(31) 3228-6200",
  linkWhatsapp: `https://wa.me/553132286200`
};

export const INITIAL_STATE = {
  categoriaExameSelecionada: categoriaExameInformacao.Todos,
  buscaMultiplaHabilitada: false,
  listaCompletaExames: [],
  listaExamesFiltrados: [],
  listaExamesBuscaMultipla: [],
  tipoApoioSelecionado: undefined,
  unidadeProdutivaSelecionada: undefined,
  unidadeDeNegocioSelecionado: undefined,
  empresaPscSelecionada: undefined,
  codigoLc: undefined,
  baixandoPdf: false,
  loadingVisualizacaoExame: false,
  atualizandoPesquisaExame: false,
  rodapeEmpresa: rodapeEmpresaInitialState
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ATUALIZAR_BAIXANDO_PDF: {
      return {
        ...state,
        baixandoPdf: action.payload
      };
    }
    case ATUALIZAR_CATEGORIA_EXAME_SELECIONADA: {
      return {
        ...state,
        categoriaExameSelecionada: action.payload
      };
    }
    case ATUALIZAR_LISTA_COMPLETA_EXAMES: {
      return {
        ...state,
        listaCompletaExames: action.payload
      };
    }
    case ATUALIZAR_LISTA_EXAMES_FILTRADOS: {
      return {
        ...state,
        listaExamesFiltrados: action.payload
      };
    }
    case ATUALIZAR_LISTA_EXAMES_BUSCA_MULTIPLA: {
      return {
        ...state,
        listaExamesBuscaMultipla: action.payload
      };
    }
    case ATUALIZAR_BUSCA_MULTIPLA_HABILITADA: {
      return {
        ...state,
        buscaMultiplaHabilitada: action.payload
      };
    }
    case ATUALIZAR_TIPO_APOIO: {
      return {
        ...state,
        tipoApoioSelecionado: action.payload
      };
    }
    case ATUALIZAR_UNIDADE_PRODUTIVA: {
      return {
        ...state,
        unidadeProdutivaSelecionada: action.payload
      };
    }
    case ATUALIZAR_UNIDADE_DE_NEGOCIO: {
      return {
        ...state,
        unidadeDeNegocioSelecionado: action.payload
      };
    }
    case ATUALIZAR_EMPRESA_PSC: {
      return {
        ...state,
        empresaPscSelecionada: action.payload
      };
    }
    case ATUALIZAR_CODIGO_LC: {
      return {
        ...state,
        codigoLc: action.payload
      };
    }
    case LIMPAR_FILTROS_EXAME: {
      return {
        ...state,
        unidadeDeNegocioSelecionado: undefined,
        empresaPscSelecionada: undefined,
        codigoLc: undefined,
        tipoApoioSelecionado: undefined,
        unidadeProdutivaSelecionada: undefined
      };
    }
    case ATUALIZAR_LOADING_VISUALIZACAO_EXAME: {
      return {
        ...state,
        loadingVisualizacaoExame: action.payload
      };
    }
    case ATUALIZAR_PESQUISA_EXAME: {
      return {
        ...state,
        atualizandoPesquisaExame: action.payload
      };
    }
    case GERAR_RODAPE_EMPRESA: {
      return {
        ...state,
        rodapeEmpresa: action.payload
      };
    }
    default: {
      return state;
    }
  }
}

// Action creators
export const atualizarBaixandoPdf = status => {
  return {
    type: ATUALIZAR_BAIXANDO_PDF,
    payload: status
  };
};

export const atualizarBuscaMultiplaHabilitada = buscaMultiplaHabilitada => {
  return {
    type: ATUALIZAR_BUSCA_MULTIPLA_HABILITADA,
    payload: buscaMultiplaHabilitada
  };
};

export const atualizarCategoriaExameSelecionada = categoriaExameSelecionada => {
  return {
    type: ATUALIZAR_CATEGORIA_EXAME_SELECIONADA,
    payload: categoriaExameSelecionada
  };
};

export const atualizarListaCompletaExames = listaCompletaExames => {
  return {
    type: ATUALIZAR_LISTA_COMPLETA_EXAMES,
    payload: listaCompletaExames
  };
};

export const atualizarListaExamesFiltrados = listaExamesFiltrados => {
  return {
    type: ATUALIZAR_LISTA_EXAMES_FILTRADOS,
    payload: listaExamesFiltrados
  };
};

export const atualizarListaExamesBuscaMultipla = listaExamesBuscaMultipla => {
  return {
    type: ATUALIZAR_LISTA_EXAMES_BUSCA_MULTIPLA,
    payload: listaExamesBuscaMultipla
  };
};

export const atualizarTipoApoio = tipoApoio => {
  return {
    type: ATUALIZAR_TIPO_APOIO,
    payload: tipoApoio
  };
};

export const atualizarUnidadeProdutiva = unidadeProdutiva => {
  return {
    type: ATUALIZAR_UNIDADE_PRODUTIVA,
    payload: unidadeProdutiva
  };
};

export const atualizarUnidadeDeNegocio = unidadeNegocio => {
  return {
    type: ATUALIZAR_UNIDADE_DE_NEGOCIO,
    payload: unidadeNegocio
  };
};

export const atualizarEmpresaPsc = empresaPsc => {
  return {
    type: ATUALIZAR_EMPRESA_PSC,
    payload: empresaPsc
  };
};

export const atualizarCodigoLc = codigoLc => {
  return {
    type: ATUALIZAR_CODIGO_LC,
    payload: codigoLc
  };
};

export const limparFiltrosExame = () => {
  return {
    type: LIMPAR_FILTROS_EXAME
  };
};

export const atualizarLoadingVisualizacaoExame = loadingVisualizacaoExame => {
  return {
    type: ATUALIZAR_LOADING_VISUALIZACAO_EXAME,
    payload: loadingVisualizacaoExame
  };
};

export const atualizarPesquisaExame = atualizandoPesquisaExame => {
  return {
    type: ATUALIZAR_PESQUISA_EXAME,
    payload: atualizandoPesquisaExame
  };
};

export const gerarDadosRodape = rodapeEmpresa => {
  return {
    type: GERAR_RODAPE_EMPRESA,
    payload: rodapeEmpresa
  };
};
